<template>
  <div class="flex items-center q-mb-xs">
    <span class="label-block text-bold"
      >{{ earType === 'source' ? 'Source APMID' : 'Destination APMID' }} {{ registrationData.digitalServiceApm }}:</span
    >
    <div class="flex items-center q-ml-lg">
      <span>Show segments</span>
      <q-toggle keep-color class="custom-toggle" :dark="false" color="primary" v-model="showIps"> </q-toggle>
      <span>Show IP's</span>
    </div>
    <q-btn
      class="filter-icon q-ml-auto btn--no-hover"
      :class="{ active: showFilters }"
      icon="filter_alt"
      flat
      :ripple="false"
      @click="showFilters = !showFilters"
    >
      <q-tooltip>{{ showFilters ? 'Hide filters' : 'Show filters' }}</q-tooltip>
    </q-btn>
    <q-btn
      v-if="mode === 'read'"
      flat
      size="md"
      style="width: 30px"
      icon="edit"
      class="btn--no-hover"
      @click="goToRegistration($event)"
    >
      <q-tooltip>Edit Firewall Rule (EAR) Request</q-tooltip>
    </q-btn>
  </div>
  <div v-if="showFilters">
    <div class="row no-wrap full-width q-mt-sm q-mb-xs q-col-gutter-sm">
      <div v-if="$route.query?.itemId" class="col">
        <q-input
          v-model="filters.id"
          label="ID"
          outlined
          dense
          clearable
          @update:model-value="filterTable()"
          class="q-mb-sm"
        ></q-input>
      </div>
      <div class="col">
        <q-select
          v-model="filters.status"
          :options="[
            { label: 'Completed', value: 'completed' },
            { label: 'In progress', value: 'inprogress' },
            { label: 'Failed', value: 'failed' },
            { label: 'Removed', value: 'removed' },
          ]"
          emit-value
          map-options
          options-dense
          @update:model-value="reloadTable()"
          label="Status"
          clearable
          outlined
          dense
          class="q-mb-sm"
        ></q-select>
      </div>
      <div class="col">
        <q-input
          v-model="filters.port"
          label="Port"
          outlined
          dense
          clearable
          @update:model-value="filterTable()"
          class="q-mb-sm"
        ></q-input>
      </div>
      <div class="col">
        <q-select
          v-model="filters.protocol"
          :options="[
            { label: 'TCP', value: 'tcp' },
            { label: 'UDP', value: 'udp' },
            { label: 'ICMP', value: 'icmp' },
          ]"
          emit-value
          map-options
          options-dense
          label="Protocol"
          outlined
          dense
          clearable
          @update:model-value="reloadTable()"
          class="q-mb-sm"
        ></q-select>
      </div>
      <div class="col">
        <q-input
          v-model="filters.srcIp"
          label="SRC IP"
          outlined
          dense
          clearable
          @update:model-value="filterTable()"
          class="q-mb-sm"
        ></q-input>
      </div>
      <div class="col">
        <q-input
          v-model="filters.dstIp"
          label="DST IP"
          outlined
          dense
          clearable
          @update:model-value="filterTable()"
          class="q-mb-sm"
        ></q-input>
      </div>
    </div>
  </div>
  <FirewallRulesTable
    ref="itemsTable"
    :showIps="showIps"
    :mode="mode"
    :filters="filters"
    @duplicate="$emit('duplicate', $event)"
  />
</template>

<script>
import FirewallRulesTable from '@/shared/components/FirewallRulesTable.vue';
import { supportCntrlClick } from '@/shared/helpers';

export default {
  name: 'EarWidget',
  components: {
    FirewallRulesTable,
  },
  props: {
    registrationId: {
      type: String,
    },
    registrationData: {
      type: Object,
    },
    mode: {
      type: String,
    },
    earType: {
      type: String,
    },
  },
  data() {
    return {
      showIps: true,
      showFilters: false,
      timeout: undefined,
      filters: {
        id: undefined,
        registrationId: this.registrationId,
        digitalService: undefined,
        infraService: undefined,
        sourceIp: undefined,
        targetIp: undefined,
        sourceApmId: this.earType === 'source' ? this.registrationData.digitalServiceApm : undefined,
        targetApmId: this.earType === 'target' ? this.registrationData.digitalServiceApm : undefined,
        sourceServiceName: undefined,
        targetServiceName: undefined,
        sourceEnv: undefined,
        targetEnv: undefined,
        sourceDatacenter: undefined,
        targetDatacenter: undefined,
        dateFrom: undefined,
        dateTo: undefined,
        status: undefined,
      },
    };
  },
  methods: {
    filterTable() {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        this.reloadTable();
      }, 1500);
    },
    reloadTable() {
      this.$refs.itemsTable.reload();
    },
    goToRegistration(event) {
      supportCntrlClick(
        event,
        `/my-portfolio/${this.registrationData.digitalServiceApm}/registration/${this.registrationId}?tab=firewall-rules`,
      );
    },
  },
  mounted() {
    if (this.$route.query?.itemId) {
      this.filters.id = this.$route.query?.dnsRecordId;
      if (this.$route.query?.source === this.registrationData.digitalServiceApm && this.earType === 'source') {
        this.showFilters = true;
        this.filters.id = this.$route.query?.itemId;
      }
      if (this.$route.query?.source !== this.registrationData.digitalServiceApm && this.earType !== 'source') {
        this.showFilters = true;
        this.filters.id = this.$route.query?.itemId;
      }
    }
    this.reloadTable();
  },
};
</script>
